import { IdType } from 'epic/common-form/ReloadFormRequest';
import { connect } from 'react-redux';
import type { DailyBlotterQuote } from 'state/blotters/dailyBlotter/dailyBlotter.model';
import { getDailyBlotterColumnsDefinition, getDailyBlotterQuote } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { workspaceTabQuoteRepriced } from 'state/workspaces/workspace.actions';

import type { ColumnDefinition } from '../DailyBlotter.model';

interface OwnProps {
  quoteId: string;
}

interface StateProps {
  dailyBlotterQuote: DailyBlotterQuote;
  dailyBlotterColumnsDefinition: ColumnDefinition[];
}

interface DispatchProps {
  onReprice: (tabId: string, quote: DailyBlotterQuote) => void;
}

export type DailyBlotterRowProps = OwnProps & StateProps & DispatchProps;

const mapStateToProps = (state: AppState, { quoteId }: OwnProps): StateProps => {
  return {
    dailyBlotterQuote: getDailyBlotterQuote(state, quoteId),
    dailyBlotterColumnsDefinition: getDailyBlotterColumnsDefinition(state),
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  onReprice(tabId, quote) {
    dispatch(
      workspaceTabQuoteRepriced(
        tabId,
        quote.productId,
        IdType.ProductId,
        quote.rfqId,
        quote.pricerRfqId,
        'static',
        true,
        undefined,
        quote.externalQuoteId,
      ),
    );
  },
});
export const connectDailyBlotterRow = connect(mapStateToProps, mapDispatchToProps);
